import { render, staticRenderFns } from "./PrivatePersonAgreement.vue?vue&type=template&id=65dfefeb&scoped=true&"
import script from "./PrivatePersonAgreement.vue?vue&type=script&lang=js&"
export * from "./PrivatePersonAgreement.vue?vue&type=script&lang=js&"
import style0 from "./PrivatePersonAgreement.vue?vue&type=style&index=0&id=65dfefeb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dfefeb",
  null
  
)

export default component.exports